export const GLOBAL_NAV_URL_PARAM = 'gnav';
